import React from 'react';
import PropTypes from 'prop-types';
import translate from 'components/hoc/translate';
import utils from 'helpers/utils';
import theme from 'theme/theme';

const styles = {
    prices: {
        box: {
            display: 'flex',
            justifyContent: 'space-around',
            color: theme.palette.black,
        },
        element: {
            display: 'flex',
            flexDirection: 'column',
            minWidth: '100px',
        },
        difference: {
            display: 'flex',
            justifyContent: 'space-around',
            alignItems: 'center',
        },
        icon: {
            marginRight: '10px',
        },
        label: {
            display: 'flex',
            height: '30px',
            justifyContent: 'center',
            fontSize: '16px',
        },
        value: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: '20px',
            fontWeight: 'bold',
        },
    },
    wrapper: {
        marginTop: '30px',
        width: '700px',
    },
};

const Price = (props, context) => {
    const {
        prices,
        translate,
    } = props;

    const {
        locale,
    } = context;

    return (
        <div style={ styles.wrapper }>
            <div style={ styles.prices.box }>
                <div style={ styles.prices.element }>
                    <div style={ styles.prices.label }>
                        { translate('resources.bookings.amend.prices.difference') }
                    </div>
                    <div style={ styles.prices.value }>
                        <div style={ styles.prices.difference }>
                            <div>
                                { utils.formatPrice(prices.difference, prices.currency, locale) }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

Price.contextTypes = {
    locale: PropTypes.string,
};

Price.propTypes = {
    prices: PropTypes.object,
    translate: PropTypes.func.isRequired,
};

export default translate(Price);



// WEBPACK FOOTER //
// ./src/pages/bookings/amend/phase/form/Prices.js